const func = $target => {
	var $confirm = $('input#' + $target.attr('id') + 'Confirm');

	$target.on('blur', function(e) {
		$confirm.attr('pattern', $target.val());
	});
	$target.on('keyup', function(e) {
		$confirm.attr('pattern', $target.val());
	});

	$target.parents('form').on('submit', function(e) {
		$confirm.attr('pattern', $target.val());
	});
};

export default func;
